import List from "@/store/Abstract/List";
import Update from "@/store/Abstract/Update";
import { State } from "./state";
import Mutations from "./mutations";
import Getters from "./getters";
import Actions from "./actions";
export default class Broadcast {
    namespaced = true;
    state;
    mutations = Mutations;
    getters = Getters;
    actions = Actions;
    modules;
    constructor() {
        this.state = new State();
        this.modules = {
            list: new List(),
            markAsSeen: new Update(),
        };
    }
}
